import { Box, TextField, Typography, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";
import { getHeader } from "../../utils/utils2";

const AddSupplierItem = ({ onAdded, show, mode = "add", editItem }) => {
  const [supplierName, setSupplierName] = useState("");
  const [address, setAddress] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [emails, setEmails] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (mode === "edit" && editItem) {
      setSupplierName(editItem.supplierName || "");
      setAddress(editItem.address || "");
      setContactPerson(editItem.contactPerson || "");
      setEmails(editItem.emails?.join(", ") || "");
      setPhoneNumber(editItem.phoneNumber || "");
    } else {
      clearFields();
    }
  }, [mode, show, editItem]);

  const handleAddSupplier = async () => {
    if (!supplierName) return toast.error("Supplier name required");
    if (!address) return toast.error("Address required");
    if (!contactPerson) return toast.error("Contact person required");
    if (!emails) return toast.error("Emails required");
    if (!phoneNumber) return toast.error("Phone number required");

    setLoading(true);

    try {
      // Build payload dynamically to avoid repeating code
      const payload = {
        supplierName,
        address,
        contactPerson,
        // Filter removes empty strings if the user leaves a trailing comma
        emails: emails
          .split(",")
          .map((email) => email.trim())
          .filter(Boolean),
        phoneNumber,
        mode,
        ...(mode === "edit" && { id: editItem?._id }),
      };

      const { data } = await axios.post(
        `${API_ENDPOINT}/admin/add-supplier`,
        payload,
        getHeader()
      );

      toast.success(data.message);
      onAdded();
    } catch (error) {
      toastError(error);
    } finally {
      setLoading(false);
    }
  };

  function clearFields() {
    setSupplierName("");
    setAddress("");
    setContactPerson("");
    setEmails("");
    setPhoneNumber("");
  }

  return (
    <Box m={3}>
      <Typography variant="h5" mb={3}>
        {mode === "edit" ? "Edit Supplier" : "Add Supplier"}
      </Typography>

      <TextField
        type="text"
        size="small"
        label="Supplier Name"
        value={supplierName}
        onChange={(e) => setSupplierName(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        type="text"
        size="small"
        label="Address"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        type="text"
        size="small"
        label="Contact Person"
        value={contactPerson}
        onChange={(e) => setContactPerson(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        type="email"
        size="small"
        label="Emails"
        helperText="For multiple emails, use comma-separated values"
        value={emails}
        onChange={(e) => setEmails(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <TextField
        type="text"
        size="small"
        label="Phone Number"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />

      <Stack mt={2} direction={"row"}>
        <Box flex={1}></Box>
        <LoadingButton
          loading={loading}
          variant="contained"
          onClick={handleAddSupplier}
          sx={{ mb: 2 }}
        >
          Save
        </LoadingButton>
      </Stack>
    </Box>
  );
};

export default AddSupplierItem;
